import { c as _c } from "react/compiler-runtime";
import OrderSelect from '@/components/modules/ListOptionsBar/OrderSelect';
import { BReviewOrderEnum } from '@/types/backend';
import useReviewsOrder from '../context/useReviewsOrder';
const ORDERED_REVIEW_ORDERS = [
    BReviewOrderEnum.CreatedDesc,
    BReviewOrderEnum.CreatedAsc,
    BReviewOrderEnum.NoteDesc,
    BReviewOrderEnum.NoteAsc
];
const ReviewsOrder = (t0) => {
    const $ = _c(7);
    const { formId, disabled } = t0;
    const { order, setOrder } = useReviewsOrder();
    let t1;
    if ($[0] !== setOrder) {
        t1 = (e) => {
            setOrder(e.target.value);
        };
        $[0] = setOrder;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const handleChange = t1;
    let t2;
    if ($[2] !== disabled || $[3] !== formId || $[4] !== handleChange || $[5] !== order) {
        t2 = <OrderSelect formId={formId} onChange={handleChange} value={order} possibleOrders={ORDERED_REVIEW_ORDERS} disabled={disabled}/>;
        $[2] = disabled;
        $[3] = formId;
        $[4] = handleChange;
        $[5] = order;
        $[6] = t2;
    }
    else {
        t2 = $[6];
    }
    return t2;
};
export default ReviewsOrder;
